import React from 'react';
import { useTranslation } from 'react-i18next';
import { addDays } from 'date-fns';

import { OmaLummeApp } from '../../omaLummeContext';

import styles from './styles/LatestInvoice.module.scss';

// Types.
import { InvoiceDetails } from '../../types/consumptionRates';
import { generateAddress } from '../../utils/address';
// Utils.
import { formatDate } from '../../utils/billing';
import { disableEInvoiceOrder } from './Billing';

const LatestInvoice: React.FunctionComponent<InvoiceDetails> = (props: InvoiceDetails) => {
  const { t } = useTranslation();
  const { users } = OmaLummeApp.useState();
  const { customerType } = users.activeUser;
  const { customerId, meteringPointAddress, company, invoiceState, invoiceDue, invoiceNumber, paymentType, postponable } = props.invoiceDetails;
  const { postponed, setPostponeVisibility } = props.postpone;
  const { setChangingPaymentMethod, paymentMethodUpdated } = props;

  const idString = `${customerId}-${invoiceNumber}`;

  const postPonedString = postponable && postponed === idString;

  return (
    <div className={styles.details}>
      <div className="address">{meteringPointAddress && <span>{generateAddress(meteringPointAddress, false)}</span>}</div>
      <div className="detail">
        <span className="bold-text">{t('billing:billing.receiver')}</span>
        <span>{company}</span>
      </div>
      <div className="detail">
        <span className="bold-text">{t('billing:billing.billState')}</span>
        {!postPonedString && <span className={invoiceState === 'open' ? `bold-text ${styles.alert}` : ''}>{invoiceState}</span>}
        {postPonedString && <span>{t('consumption:consumption.postponed')}</span>}
      </div>
      <div className="detail">
        <span className="bold-text">{t('billing:billing.dueDate')}</span>
        <span>
          {postPonedString ? formatDate(addDays(new Date(invoiceDue), 14).toISOString()) : formatDate(invoiceDue)}

          {postponable && postponed !== idString && (
            <button className={`${styles.postponeInvoice} underline`} onClick={(): void => setPostponeVisibility(idString)}>
              {t('consumption:consumption.postponeBill')}
            </button>
          )}
        </span>
      </div>
      <div className="detail">
        <span className="bold-text">{t('billing:billing.billNumber')}</span>
        <span>{invoiceNumber}</span>
      </div>
      {paymentType && (
        <>
          <div className="detail">
            <span className="bold-text">{t('billing:billing.paymentMethod')}</span>
            <span>{t(`billing:paymentTypes.${paymentType}`)}</span>
          </div>

          {!disableEInvoiceOrder && !paymentMethodUpdated && paymentType === 1 && customerType !== 'business' && (
            <div className={`detail ${styles.changePaymentMethod}`}>
              <span></span>
              <span>
                <button onClick={() => setChangingPaymentMethod(true)} className={`${styles.postponeInvoice} underline`}>
                  {t('consumption:consumption.changePaymentMethod')}
                </button>
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LatestInvoice;
